import { Header } from "antd/es/layout/layout";
import styled from "styled-components";

export const StyledHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  padding-right: 10px !important;
  padding-left: 10px !important;
`;
